/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/Commit/CommitLayer" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { createHistoryAwareLayer } from "VSS/Features/MasterDetails";
import { IVssPageContext } from "VSS/Platform/Context";
import { MasterPanelHeader } from "VSSUI/MasterDetails";
import { IMasterDetailsContextLayer } from "VSSUI/MasterDetailsContext";
import { ICommit, IPullRequest } from "../../SampleData";
import { CommitDetailsContent } from "./CommitDetailsContent";
import { CommitMasterContent } from "./CommitMasterContent";

export function getCommitLayer(
    commit: ICommit,
    pullRequest: IPullRequest,
    pageContext: IVssPageContext
): IMasterDetailsContextLayer<ICommit, IPullRequest> {
    return createHistoryAwareLayer(
        {
            key: "commit",
            selectedMasterItem: new ObservableValue<ICommit>(commit),
            detailsContent: {
                renderContent: (selectedItem: ICommit) => <CommitDetailsContent commit={selectedItem} />
            },
            masterPanelContent: {
                renderHeader: (parentItem: IPullRequest) => <MasterPanelHeader title={parentItem.title} subTitle={parentItem.author} />,
                renderContent: (parentItem, selectedItem) => <CommitMasterContent initialSelectedMasterItem={selectedItem} parentItem={parentItem} />
            },
            parentItem: pullRequest
        },
        pageContext,
        item => item.hashCode,
        itemAsString => pullRequest.commits.find(x => x.hashCode === itemAsString)!
    );
}
